<template>
    <div class="editor"
         :class="{'disabled':data.disabled}">
        <textarea
            :id="inputFieldId"
            :name="name"
        />
    </div>
</template>

<script>
import {InputMixin} from './mixin/InputMixin.js';

export default {
    name: "TextEditor",
    mixins: [InputMixin],
    data() {
        return {
            isInitialized: false
        }
    },
    mounted() {
        $("#" + this.inputFieldId).on("summernote.change", () => {
            this.input()
        });
        setTimeout(() => {
            this.initComponent(this.value);
        })
    },
    watch: {
        editorValue: function (value, oldValue) {
            // Only update if summernote is initialized and value changed externally
            if (!this.isInitialized) return;
            const currentCode = $("#" + this.inputFieldId).summernote('code');
            if (value !== currentCode) {
                this.setInitValue(value);
            }
        }
    },
    computed: {
        editorValue() {
            return this.value;
        }
    },
    methods: {
        initComponent(initialValue) {
            let config = {
                placeholder: this.data.placeholder,
                dialogsInBody: true,
                height: this.data.height,
                codeviewFilter: false,
                codeviewIframeFilter: true,
                // Use callbacks to scope styles when content changes
                callbacks: {
                    onInit: () => {
                        this.scopeEditorStyles();
                    },
                    onChange: () => {
                        this.scopeEditorStyles();
                    },
                    onPaste: () => {
                        setTimeout(() => this.scopeEditorStyles(), 100);
                    }
                }
            };
            if (Object.keys(this.data.textEditorHints).length) {
                config.hint = this.data.textEditorHints
            }
            if (this.data.minimal === true) {
                config.toolbar = [
                    ['style', ['bold', 'italic', 'underline']],
                    ['fontsize', ['fontsize', 'height', 'color']],
                    ['para', ['ul', 'ol']],
                    ['insert', ['picture', 'link', 'video']]
                ]
            }
            $("#" + this.inputFieldId).summernote(config);
            this.setInitValue(initialValue);
            this.isInitialized = true;
        },

        setInitValue(initialValue) {
            $("#" + this.inputFieldId).summernote('code', initialValue);
            setTimeout(() => this.scopeEditorStyles(), 100);
        },

        input() {
            this.fieldValue = $('#' + this.inputFieldId).summernote('code');
            this.$emit('input', this.fieldValue);
        },

        /**
         * Scope <style> tags within the editor to prevent them from affecting the page.
         * This extracts styles, prefixes selectors with a unique ID, and re-injects them.
         */
        scopeEditorStyles() {
            const editorEl = $('#' + this.inputFieldId).next('.note-editor');
            const editableEl = editorEl.find('.note-editable');

            if (!editableEl.length) return;

            // Generate unique scope ID for this editor instance
            const scopeId = 'editor-scope-' + this.inputFieldId;
            editableEl.attr('id', scopeId);

            // Find all style tags in the editable area
            const styleTags = editableEl.find('style');

            styleTags.each((index, styleTag) => {
                const $style = $(styleTag);
                let cssText = $style.text();

                // Skip if already scoped
                if ($style.attr('data-scoped')) return;

                // Scope the CSS by prefixing selectors with the editor scope ID
                const scopedCss = this.scopeCss(cssText, '#' + scopeId);

                // Replace the style content with scoped version
                $style.text(scopedCss);
                $style.attr('data-scoped', 'true');
            });
        },

        /**
         * Prefix CSS selectors with a scope selector to isolate styles.
         */
        scopeCss(css, scopeSelector) {
            // Simple CSS scoping - prefix each selector with the scope
            // This handles most common cases but may not cover all edge cases
            return css.replace(/([^\r\n,{}]+)(,(?=[^}]*{)|\s*{)/g, (match, selector, suffix) => {
                // Skip @rules like @media, @keyframes, etc.
                if (selector.trim().startsWith('@')) {
                    return match;
                }
                // Skip selectors that are already scoped or are keyframe percentages
                if (selector.includes(scopeSelector) || /^\s*(\d+%|from|to)\s*$/.test(selector)) {
                    return match;
                }
                // Scope the selector
                return scopeSelector + ' ' + selector.trim() + suffix;
            });
        }
    }
}
</script>
